import axios from 'axios';
import {clearDataRequest} from  '../../../plugins/utils';

const state = {
    seamans: [],
    paginate: {},
    dataRequest: {},
    selectedVT: { pvt: 0, vt: 0, prank: 0, rank:0, en:0, cnt:0},
    vesselsType: [],
    ranks: [],
    showMatrix: false,
    tankerRanks: {y:0, ty:0, btn:false},


};
const getters = {
    seamans: state => state.seamans,
    paginate: state => state.paginate,
    vesselsType: state=>state.vesselsType,
    selectedVT: state => state.selectedVT,
    dataRequest: state => state.dataRequest,
    ranks: state => state.ranks,
    tankerRanks: state => state.tankerRanks,
    showMatrix: state => state.showMatrix,

};
const mutations = {
    setVesselsType: (state, payload) => state.vesselsType = payload,
    prepareRequest: (state, payload) => state.dataRequest[payload.key] = payload.val,
    setSelectedVT: (state, payload) => state.selectedVT[payload.key] = payload.val,
    setRanks: (state, payload) => state.ranks = payload,
    setTankerRanks: (state, payload) => state.tankerRanks[payload.key] = payload.val,
    filterSeamans : (state, payload) => state.seamans = payload,
    setShowMatrix : (state, payload) => state.showMatrix = payload,

    setSeamans: (state, payload) => {
        state.seamans = payload.data;
        state.paginate = {
                current_page: payload.current_page,
                total: payload.total,
                from: payload.from,
                to: payload.to,
                last_page: payload.last_page,
                per_page: payload.per_page
            }

    },
   sendRequest: (state, payload) => {
         state.dataRequest['action'] = 'getFilteredData';
        clearDataRequest(state.dataRequest);
         axios.post(location.href, state.dataRequest)
            .then(response => {
                let items = response.data.seamans;
                state.seamans = items.data;
                state.paginate = {
                    current_page: items.current_page,
                    total: items.total,
                    from: items.from,
                    to: items.to,
                    last_page: items.last_page,
                    per_page: items.per_page
                }
            });

    }


};
const actions = {
    setVesselsType: ({commit}, payload) => commit('setVesselsType', payload),
    prepareRequest: ({commit}, payload) => commit('prepareRequest', payload),
    setRanks: ({commit}, payload) => commit('setRanks', payload),
    setTankerRanks: ({commit}, payload) => commit('setTankerRanks', payload),
    filterSeamans: ({commit}, payload) => commit('filterSeamans', payload),
    setSeamans: ({commit}, payload) => commit('setSeamans', payload),
    sendRequest: ({commit}, payload) => commit('sendRequest', payload),
    setShowMatrix: ({commit}, payload) => commit('setShowMatrix', payload),
    setSelectedVT: ({commit}, payload) => commit('setSelectedVT', payload),

};


export default {
    state, getters,mutations, actions
}


// WEBPACK FOOTER //
// ./vue/frontfilter/store/modules/filter.js